var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff00b1;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:13px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97",
    "data-name": "Layer 97"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.44,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.56,196.88q0-25,16-50.61t46.8-42.45Q262.14,87,303.15,87q38.12,0,67.31,14.07t45.08,38.25a93.83,93.83,0,0,1,15.9,52.58q0,22.34-9.06,39.17a120.26,120.26,0,0,1-21.56,29.05Q388.33,272.32,356,301.25a181.1,181.1,0,0,0-14.33,14.33,57.75,57.75,0,0,0-8,11.3,55.33,55.33,0,0,0-4.07,10.25q-1.45,5.13-4.34,18-5,27.35-31.29,27.34-13.67,0-23-8.94T261.62,347q0-22.08,6.83-38.25a97.26,97.26,0,0,1,18.14-28.39,416.58,416.58,0,0,1,30.5-29.05q16.82-14.72,24.32-22.22A75,75,0,0,0,354,212.39a40.33,40.33,0,0,0,5.13-20q0-21-15.64-35.49t-40.36-14.46q-28.92,0-42.58,14.59t-23.14,43q-8.94,29.7-33.91,29.7a33.32,33.32,0,0,1-24.84-10.38Q168.56,209,168.56,196.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 299.92,
    cy: 464,
    r: 39.04
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.64b7a053d05aae02a709e9a5783dd9d1.svg";
export { ForwardRef as ReactComponent };